import React, { Children, cloneElement, createContext, isValidElement, useContext } from 'react';
import IconAction from './IconAction';

const IconActionsContext = createContext(false);
export const useIconActions = () => useContext(IconActionsContext);

// Adapt explicitly supplied footer actions; never inspect or mutate rendered DOM.
function decorateActions(children) {
  return Children.map(children, (child) => {
    if (!isValidElement(child) || child.type === IconAction || child.props['data-icon-action'] != null)
      return child;
    if (
      child.type === 'button' ||
      child.type === 'a' ||
      child.props.to ||
      ['AlertDialogAction', 'AlertDialogCancel', 'DialogClose'].includes(child.type?.displayName)
    ) {
      return <IconAction asChild>{child}</IconAction>;
    }
    return child.props.children ? cloneElement(child, {}, decorateActions(child.props.children)) : child;
  });
}
export default function IconActions({ children }) {
  return <IconActionsContext.Provider value>{decorateActions(children)}</IconActionsContext.Provider>;
}
